import {defineMessages} from 'react-intl'

export default defineMessages({
    comingSoon:{
        id:'containers.ProjectPage.components.ProjectVideo.comingSoon',
        defaultMessage:'Coming soon'
    }
})
